import React from 'react'
import Button from '../Button'

const Sections = ({ items }) => (
  <div className='border rounded-1'>
    {items.map((d, i) => (
      <div key={i} className={`section d-flex align-items-center justify-content-between flex-column flex-md-row bg-light-hover pointer px-2 ${i < items.length - 1 ? 'border-bottom' : ''}`} onClick={d.onClick}>
        <div>
          {d.title}
        </div>
        <div className='d-flex align-items-center flex-row text-right'>
          <div className='text-muted'>{d.status}</div>
          <div className='text-right'>
            <Button ghost className='rounded-circle text-muted'>
              <span className='fa-solid fa-arrow-right' title={`Click ${d.title}`} />
            </Button>
          </div>
        </div>
      </div>
    ))}
  </div>
)

export default Sections
